module.exports = __webpack_public_path__ + "img/water-meter-cold-md.ca30cba7.svg";